__turbopack_context__.v({
  "className": "inter_1ea13f0-module__GZDeqG__className",
});
